import React from "react";
import { EDGE } from "./edgeTokens";

const FOCUS =
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1A1A1A]";

// Reusable Edge answer type: pick one of a few labelled options, graded on
// Submit. Before Submit the choice is neutral (teal registration). After it,
// the same marker language as the tap Reads:
//   your choice, right   teal check
//   your choice, wrong   grey dashed border, "Your answer"
//   the right option     gold border, "Correct answer"
// Never green for right or red for wrong: those colours belong to price.
//
//   options   [{ id, label }]
//   value     chosen id or null
//   onChange  (id) => void
//   disabled  no choosing (e.g. while the sequence is still playing)
//   correctId set after Submit to show the result
export default function ChoiceAnswer({ options, value, onChange, disabled, correctId, label }) {
  const graded = correctId != null;
  return (
    <div role="radiogroup" aria-label={label} className="grid grid-cols-2 gap-2">
      {options.map((o) => {
        const chosen = value === o.id;
        const right = graded && o.id === correctId;
        let cls = "border border-gray-200 text-bodyInk bg-white";
        let note = null;
        if (!graded && chosen) cls = "border-2 border-primaryColor text-primaryColor bg-white";
        if (graded && chosen && right) cls = "border-2 border-primaryColor text-bodyInk bg-white";
        if (graded && chosen && !right) {
          cls = "border-2 border-dashed border-[#9CA3AF] text-bodyInk bg-white";
          note = "Your answer";
        }
        if (graded && right && !chosen) {
          cls = "border-2 border-[#D7C588] text-bodyInk bg-[#D7C588]/10";
          note = "Correct answer";
        }
        return (
          <button
            key={o.id}
            type="button"
            role="radio"
            aria-checked={chosen}
            disabled={disabled || graded}
            onClick={() => onChange(o.id)}
            className={`relative min-h-[48px] rounded-lg px-2 py-2 font-semibold text-[15px] ${cls} ${FOCUS} ${
              disabled && !graded ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            <span className="flex items-center justify-center gap-1.5">
              {graded && chosen && right && <Check />}
              {o.label}
            </span>
            {note && <span className="block text-xs font-medium text-secondary">{note}</span>}
          </button>
        );
      })}
    </div>
  );
}

function Check() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M3 8.3l3.4 3.4L13 4.8" fill="none" stroke={EDGE.teal} strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
